import { GenerateAwsPresignedUrlDocument } from 'domain/usecases/document/generate-aws-presigned-url-document'
import { AwsDocumentRepository } from 'repository/interfaces/aws-document-repository'

export class RemoteGenerateAwsPresignedUrlDocument
  implements GenerateAwsPresignedUrlDocument
{
  private readonly documentRepository: AwsDocumentRepository

  constructor(documentRepository: AwsDocumentRepository) {
    this.documentRepository = documentRepository
  }

  generate(
    params: GenerateAwsPresignedUrlDocument.Params
  ): Promise<GenerateAwsPresignedUrlDocument.Model> {
    return this.documentRepository.generateAwsPresignedUrlDocument(params)
  }
}

export type GenerateAwsPresignedUrlDocumentModel =
  GenerateAwsPresignedUrlDocument.Model
